export default {
  items : [
    {
      title: '海康威视战略合作伙伴',
      subTitle: '',
      url: 'p1_2.jpeg'
    },
    {
      title: '资深软件开发团队',
      subTitle: '',
      url: 'p2_2.jpeg'
    }
  ]
}


// WEBPACK FOOTER //
// ./src/pages/home/components/banner/config.js